
import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col, Alert } from "react-bootstrap";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { fetchClientData } from "../../redux/client/clientSlice";
import { useDispatch } from "react-redux";
import api from "../../utils/api";
import socket from "../../context/socket";

const ChequeFormModal = ({ show, onHide, proofType, kycDoc, roomId }) => {
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();
  const [ifscValue, setIfscValue] = useState("");
  const [ifscError, setIfscError] = useState("");

  const dispatch = useDispatch();
  const chequeDoc = kycDoc?.find((doc) => doc.doctype === "cheque");
  const chequeData = chequeDoc?.data?.[0] || {};
  console.log("chequeData", chequeData);

  useEffect(() => {
    // If chequeData is available, set the form fields
    if (chequeData && Object.keys(chequeData).length > 0) {
      setValue("fullName", chequeData.accountHolderName || "");
      setValue("bankName", chequeData.bankName || "");
      setValue("accountNo", chequeData.accountNumber || "");
      setValue("ifsc", chequeData.ifsc || "");
      setValue("micr", chequeData.micrCode || "");
      setValue("branch", chequeData.branch || "");
      setValue("address", chequeData.address || "");
      setIfscValue(chequeData.ifsc || "");
    } else {
      setValue("fullName", "");
      setValue("bankName", "");
      setValue("accountNo", "");
      setValue("ifsc", "");
      setValue("micr", "");
      setValue("branch", "");
      setValue("address", "");
      setIfscValue(""); 
    }
  }, [chequeDoc, setValue]);
  

  useEffect(() => {
    const fetchIfscDetails = async () => {
      if (!ifscValue || ifscValue.length < 11) return;

      // IFSC Code validation (4 chars + 0 + 6 digits)
      const isValidIFSC = /^[A-Z]{4}0[A-Z0-9]{6}$/i.test(ifscValue);
      if (!isValidIFSC) return;

      try {
        const response = await api.post(
          `advisor/get_ifsc_data`,
          { ifsc: ifscValue }
        );
        console.log("IFSC API responseponse", response.data);
        setIfscError("");

        setValue("bankName", response.data?.Bank_Name || "");
        setValue("ifsc", response.data?.IFSC_Code || "");
        setValue("micr", response.data?.MICR_Code || "");
        setValue("branch", response.data?.Branch || "");
        setValue("address", response.data?.Bank_Address || "");
      } catch (error) {
        console.log("Invalid IFSC or not found");

        // Capture error message from API if available
        const errMsg = error.responseponse?.data?.error || "Invalid IFSC Code";
        setIfscError(errMsg);

        // Optional: Reset disabled fields
        setValue("bankName", "");
        setValue("micr", "");
        setValue("branch", "");
        setValue("address", "");
      }
    };

    fetchIfscDetails();
  }, [ifscValue, setValue]);

  const onSubmit = async (data) => {

        Swal.fire({
          text: "Please wait...",
          imageUrl: "https://www.finedge.in/assets/images/download.gif",
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
    const payload = {
      _id: roomId,
      document_type: "cheque",
      accountHolderName: data.fullName,
      bankName: data.bankName,
      accountNumber: data.accountNo,
      ifsc: data.ifsc,
      micrCode: data.micr,
      branch: data.branch,
      address: data.address,
      data_status: true,
    };

    console.log("Submitting Cheque Payload", payload);

    try {
      const response = await api.post(
        `advisor/add_kyc_doc_data`,
        payload
      );
      // console.log('response',response.data);

      if (response.status ===200||response.status===201) {
        Swal.fire({
          icon: "success",
          text: response?.message || "Client data updated successfully",
          title: "Success",
          confirmButtonText: "OK",
          customClass: { confirmButton: "swal-confirm-btn" },
        }).then(() => {
          setValue("");
          reset();
          onHide();
          dispatch(fetchClientData(roomId));
    
          socket.emit("join", { room: roomId });
          socket.emit("message_to", 
            {
              room: roomId,
              data: { message: response?.message || "Client data updated successfully",
              type: "success",}
            
            })
          console.log("emitted data message_to", roomId, "success");
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Upload Failed',
          text: response.data?.message || 'Something went wrong!',
          confirmButtonColor: '#d33',
        });
      }
    } catch (err) {
      Swal.fire("Error", err.message || "API failed", "error");
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton style={{ backgroundColor: "#c7e69b" }}>
        <Modal.Title>{proofType} Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {ifscError && (
          <Alert
            variant="danger"
            className="mt-2 py-2 px-3"
            dismissible
            onClose={() => {
              setIfscError("");

              // Clear IFSC-related form fields
              setValue("bankName", "");
              setValue("micr", "");
              setValue("branch", "");
              setValue("address", "");
            }}
          >
            {/* <strong>Bank Error:</strong> */}
            <span className="text-danger">{ifscError}</span>
          </Alert>
        )}

        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            {/* Full Name */}
            <Col md={6}>
              <Form.Group controlId="fullName">
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter full name"
                  {...register("fullName", {
                    required: "Full Name is required",
                  })}
                />
                {errors.fullName && (
                  <p className="error text-danger">{errors.fullName.message}</p>
                )}
              </Form.Group>
            </Col>

            {/* Bank Name */}
            <Col md={6}>
              <Form.Group controlId="bankName">
                <Form.Label>Bank Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter bank name"
                  {...register("bankName", {
                    required: "Bank Name is required",
                  })}
                  disabled
                />
                {errors.bankName && (
                  <p className="error text-danger">{errors.bankName.message}</p>
                )}
              </Form.Group>
            </Col>
          </Row>

          <Row>
            {/* Account Number */}
            <Col md={6}>
              <Form.Group controlId="accountNo">
                <Form.Label>Account No.</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter account number"
                  {...register("accountNo", {
                    required: "Account No. is required",
                  })}
                />
                {errors.accountNo && (
                  <p className="error text-danger">
                    {errors.accountNo.message}
                  </p>
                )}
              </Form.Group>
            </Col>

            {/* IFSC */}
            <Col md={6}>
              <Form.Group controlId="ifsc">
                <Form.Label>IFSC Code</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter IFSC code"
                  {...register("ifsc", {
                    required: "IFSC is required",
                    onChange: (e) => {
                      const val = e.target.value.toUpperCase();
                      setIfscValue(val);
                    },
                  })}
                />
                {errors.ifsc && (
                  <p className="error text-danger">{errors.ifsc.message}</p>
                )}
              </Form.Group>
            </Col>
          </Row>

          <Row>
            {/* MICR */}
            <Col md={6}>
              <Form.Group controlId="micr">
                <Form.Label>MICR Code</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter MICR code"
                  {...register("micr")}
                  disabled
                />
                {errors.micr && (
                  <p className="error text-danger">{errors.micr.message}</p>
                )}
              </Form.Group>
            </Col>

            {/* Branch */}
            <Col md={6}>
              <Form.Group controlId="branch">
                <Form.Label>Branch</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter branch name"
                  {...register("branch", { required: "Branch is required" })}
                  disabled
                />
                {errors.branch && (
                  <p className="error text-danger">{errors.branch.message}</p>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={12}>
              <Form.Group controlId="address">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  placeholder="Enter Full address"
                  {...register("address", {
                    // required: "address is required",
                  })}
                  disabled
                />
                {errors.address && (
                  <span className="text-danger">{errors.address.message}</span>
                )}
              </Form.Group>
            </Col>
          </Row>

          <Modal.Footer className="border-0">
            <Button
              variant="secondary"
              onClick={() => {
                setIfscError(""); 
                // setIfscValue("");

                // setValue("bankName", "");
                // setValue("micr", "");
                // setValue("branch", "");
                // setValue("address", "");

                onHide(); 
              }}
            >
              Close
            </Button>

            <Button variant="success" type="submit" disabled={!!ifscError}>
              Update
            </Button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
export default ChequeFormModal;
